import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../lib/AuthContext';

/**
 * SuperAdminRoute - A protected route that only allows users with super_admin privileges
 * 
 * This component first checks if the user is authenticated, then verifies
 * if they have super admin status. If not, it redirects to the organizations page.
 */
const SuperAdminRoute = ({ children }) => {
    const { user, loading } = useAuth();

    // If still loading, show a simple loading state
    if (loading) {
        return <div className="flex min-h-screen items-center justify-center">Loading...</div>;
    }

    // If not authenticated, redirect to login
    if (!user) {
        return <Navigate to="/login" replace />;
    }

    // If authenticated but not a super admin, redirect to organizations
    if (!user.is_super_admin) {
        return <Navigate to="/organizations" replace />;
    }

    // Otherwise, render the protected content
    return children;
};

export default SuperAdminRoute; 